// extracted by mini-css-extract-plugin
export default {"plate":"plateField_plate__l1mvd"};